<script>
  import { cocktailStore } from "../store/CocktailStore";
  import { onMount } from "svelte";

  let bouteilles = {};
  let calculQteChampMajore = 0;
  let totalLitreSoupe = 0;
  let totalLitreSoupeMajore = 0;
  let calculQteChamp = 0;
  let calculQteChampByCoupe = 0;
  let qteAdjuv1Cl = 0;
  let qteAdjuv2Cl = 0;
  let qteAdjuv3Cl = 0;
  let qteAdjuv4Cl = 0;
  let qteAdjuv1ClMajore = 0;
  let qteAdjuv2ClMajore = 0;
  let qteAdjuv3ClMajore = 0;
  let qteAdjuv4ClMajore = 0;

  /***
   *  on envoi le formulaire
   */
  const submitForm = (e) => {
    const formData = new FormData(e.target);

    const data = {};

    for (let field of formData) {
      const [key, value] = field;
      data[key] = value;
    }

    $cocktailStore = data;
  };

  /**
   *  chargment des dommées
   */
  onMount(async () => {
    bouteilles = $cocktailStore;
  });

  $: {
    calculQteChampByCoupe =
      bouteilles.coupeEnCl -
      (parseFloat(bouteilles.soupeAdjuv1) +
        parseFloat(bouteilles.soupeAdjuv2) +
        parseFloat(bouteilles.soupeAdjuv3) +
        parseFloat(bouteilles.soupeAdjuv4));

    totalLitreSoupe =
      (bouteilles.nbBuveurs *
        bouteilles.coupeEnCl *
        bouteilles.nbCoupesByBuveur) /
      100;

    qteAdjuv1Cl =
      Math.round(
        ((totalLitreSoupe * bouteilles.soupeAdjuv1) / bouteilles.coupeEnCl) *
          100
      ) / 100;
    qteAdjuv2Cl =
      Math.round(
        ((totalLitreSoupe * bouteilles.soupeAdjuv2) / bouteilles.coupeEnCl) *
          100
      ) / 100;
    qteAdjuv3Cl =
      Math.round(
        ((totalLitreSoupe * bouteilles.soupeAdjuv3) / bouteilles.coupeEnCl) *
          100
      ) / 100;
    qteAdjuv4Cl =
      Math.round(
        ((totalLitreSoupe * bouteilles.soupeAdjuv4) / bouteilles.coupeEnCl) *
          100
      ) / 100;

    //console.log("calcul => " + calculQteChampByCoupe);

    calculQteChamp =
      totalLitreSoupe -
      (parseFloat(qteAdjuv1Cl) +
        parseFloat(qteAdjuv2Cl) +
        parseFloat(qteAdjuv3Cl) +
        parseFloat(qteAdjuv4Cl));

    if (bouteilles.margeSecurity != 0) {
      totalLitreSoupeMajore =
        totalLitreSoupe + (totalLitreSoupe * bouteilles.margeSecurity) / 100;

      calculQteChampMajore = Math.round(
        calculQteChamp + (calculQteChamp * bouteilles.margeSecurity) / 100,
        2
      );

      qteAdjuv1ClMajore = Math.round(
        qteAdjuv1Cl + (qteAdjuv1Cl * bouteilles.margeSecurity) / 100,
        2
      );

      qteAdjuv2ClMajore = Math.round(
        qteAdjuv2Cl + (qteAdjuv2Cl * bouteilles.margeSecurity) / 100,
        2
      );
      qteAdjuv3ClMajore = Math.round(
        qteAdjuv3Cl + (qteAdjuv3Cl * bouteilles.margeSecurity) / 100,
        2
      );
      qteAdjuv4ClMajore = Math.round(
        qteAdjuv4Cl + (qteAdjuv4Cl * bouteilles.margeSecurity) / 100,
        2
      );
    }
  }
</script>

<div class="row">
  <div class="col-xl-12">
    {#await $cocktailStore then data}
      {#if data != undefined}
        <form on:submit|preventDefault={submitForm}>
          <table class="table table-bordered table-sm">
            <tr>
              <th class="w25" />
              <th class="w25" />
              <th class="w25" />
              <th class="w25" />
              <th class="w25" />
              <th />
            </tr>
            <tr class="bg-dark text-warning">
              <td colspan="6">Base de calcul</td>
            </tr>

            <tr>
              <td> Nb personnes</td>
              <td
                ><input
                  type="number"
                  name="nbPersonnes"
                  class="form-control w25"
                  size="5"
                  id="nbPersonnes"
                  bind:value={bouteilles.nbPersonnes}
                  placeholder=""
                /></td
              >
              <td>Nb de buveurs</td>
              <td
                ><input
                  type="number"
                  name="nbBuveurs"
                  class="form-control w25"
                  size="5"
                  bind:value={bouteilles.nbBuveurs}
                  placeholder=""
                /></td
              >
              <td>Marge %</td>
              <td
                ><input
                  type="text"
                  name="margeSecurity"
                  class="form-control w25"
                  size="5"
                  id="margeSecurity"
                  bind:value={bouteilles.margeSecurity}
                  placeholder=""
                /></td
              >
            </tr>

            <tr>
              <td>Nb coupes/pers</td>
              <td
                ><input
                  type="number"
                  name="nbCoupesByBuveur"
                  class="form-control"
                  id="nbCoupeByBuveur"
                  bind:value={bouteilles.nbCoupesByBuveur}
                  placeholder=""
                /></td
              >
              <td>capacité coupe cl</td>
              <td>
                <input
                  type="text"
                  name="coupeEnCl"
                  class="form-control"
                  id="coupeEnCl"
                  bind:value={bouteilles.coupeEnCl}
                  placeholder=""
                /></td
              >
              <td colspan="2" />
            </tr>
            <!--   ====================    DETAIL DU COCKTAIL    ======================== -->
            <tr class="bg-dark text-warning">
              <td colspan="6">Récap Détail cocktail pour une coupe</td>
            </tr>

            <tr class="bg-dark text-warning">
              <td>Adujv.</td>
              <td>Qte</td>
              <td>vol.bout</td>
              <td />
              <td>Calcul</td>
              <td>vol.bout</td>
            </tr>
            <tr>
              <td>Adjv. 1 cl</td>
              <td
                ><input
                  type="text"
                  name="soupeAdjuv1"
                  class="form-control"
                  id="soupeAdjuv1"
                  bind:value={bouteilles.soupeAdjuv1}
                  placeholder=""
                /></td
              >
              <td
                ><input
                  type="text"
                  name="volumeBoutAdjuv1"
                  class="form-control"
                  id="volumeBoutAdjuv1"
                  bind:value={bouteilles.volumeBoutAdjuv1}
                  placeholder=""
                /></td
              >
              <td>Qte champ.</td>
              <td class="bg-info">{calculQteChampByCoupe} cl</td>
              <td class="bg-info">
                <input
                  type="text"
                  name="volumeBoutChamp"
                  class="form-control"
                  id="volumeBoutChamp"
                  bind:value={bouteilles.volumeBoutChamp}
                  placeholder=""
                /> cl</td
              >
            </tr>
            <tr>
              <td>Adjv. 2 cl</td>
              <td
                ><input
                  type="text"
                  name="soupeAdjuv2"
                  class="form-control"
                  id="soupeAdjuv2"
                  bind:value={bouteilles.soupeAdjuv2}
                  placeholder=""
                /></td
              >
              <td
                ><input
                  type="text"
                  name="volumeBoutAdjuv2"
                  class="form-control"
                  id="volumeBoutAdjuv2"
                  bind:value={bouteilles.volumeBoutAdjuv2}
                  placeholder=""
                /></td
              >
              <td colspan="3" />
            </tr>
            <tr>
              <td>Adjv. 3 cl</td>
              <td
                ><input
                  type="text"
                  name="soupeAdjuv3"
                  class="form-control"
                  id="soupeAdjuv3"
                  bind:value={bouteilles.soupeAdjuv3}
                  placeholder=""
                /></td
              >
              <td
                ><input
                  type="text"
                  name="volumeBoutAdjuv3"
                  class="form-control"
                  id="volumeBoutAdjuv3"
                  bind:value={bouteilles.volumeBoutAdjuv3}
                  placeholder=""
                /></td
              >
              <td colspan="3" />
            </tr>
            <tr>
              <td>Adjv. 4 cl</td>
              <td
                ><input
                  type="text"
                  name="soupeAdjuv4"
                  class="form-control"
                  id="soupeAdjuv4"
                  bind:value={bouteilles.soupeAdjuv4}
                  placeholder=""
                /></td
              >
              <td
                ><input
                  type="text"
                  name="volumeBoutAdjuv4"
                  class="form-control"
                  id="volumeBoutAdjuv4"
                  bind:value={bouteilles.volumeBoutAdjuv4}
                  placeholder=""
                /></td
              >
              <td colspan="3" />
            </tr>
            <!-- ===============    TOTAUX  ============== -->
            <tr class="bg-dark text-warning">
              <td colspan="6">Qtes totales par alcools</td>
            </tr>
            <tr>
              <td class="bg-success">Qte soupe</td>
              <td class="bg-success">{totalLitreSoupe} L</td>
              <td class="bg-warning">Qté sécurité</td>
              <td class="bg-warning" colspan="3">{totalLitreSoupeMajore} L</td>
            </tr>
            <tr>
              <td>champage</td>
              <td class="bg-info">{calculQteChamp} L</td>
              <td class="bg-info"
                >{Math.round(
                  (calculQteChamp / bouteilles.volumeBoutChamp) * 100
                ) / 100} bt</td
              >
              <td class="bg-warning">{calculQteChamp} L</td>
              <td class="bg-warning" colspan="2">{calculQteChamp} bt</td>
            </tr>
            <tr>
              <td>Adjuvant 1</td>
              <td class="bg-info">{qteAdjuv1Cl} L</td>
              <td class="bg-info"
                >{Math.round(
                  (qteAdjuv1Cl / bouteilles.volumeBoutAdjuv1) * 100
                ) / 100} bt</td
              >
              <td class="bg-warning">{qteAdjuv1ClMajore} L</td>
              <td class="bg-warning" colspan="2"
                >{Math.round(
                  (qteAdjuv1ClMajore / bouteilles.volumeBoutAdjuv1) * 100
                ) / 100} bt</td
              >
            </tr>
            <tr>
              <td>Adjuvant 2</td>
              <td class="bg-info">{qteAdjuv2Cl} L</td>
              <td class="bg-info"
                >{Math.round(
                  (qteAdjuv2Cl / bouteilles.volumeBoutAdjuv2) * 100
                ) / 100} bt</td
              >
              <td class="bg-warning">{qteAdjuv2ClMajore} L</td>
              <td class="bg-warning" colspan="2"
                >{Math.round(
                  (qteAdjuv2ClMajore / bouteilles.volumeBoutAdjuv2) * 100
                ) / 100} bt</td
              >
            </tr>
            <tr>
              <td>Adjuvant 3</td>
              <td class="bg-info">{qteAdjuv3Cl} L</td>
              <td class="bg-info"
                >{Math.round(
                  (qteAdjuv3Cl / bouteilles.volumeBoutAdjuv3) * 100
                ) / 100} bt</td
              >
              <td class="bg-warning">{qteAdjuv3ClMajore} L</td>
              <td class="bg-warning" colspan="2"
                >{Math.round(
                  (qteAdjuv3ClMajore / bouteilles.volumeBoutAdjuv3) * 100
                ) / 100} bt</td
              >
            </tr>
            <tr>
              <td>Adjuvant 4</td>
              <td class="bg-info">{qteAdjuv4Cl} L</td>
              <td class="bg-info"
                >{Math.round(
                  (qteAdjuv4Cl / bouteilles.volumeBoutAdjuv4) * 100
                ) / 100} bt</td
              >
              <td class="bg-warning">{qteAdjuv4ClMajore} L</td>
              <td class="bg-warning" colspan="2"
                >{Math.round(
                  (qteAdjuv4ClMajore / bouteilles.volumeBoutAdjuv4) * 100,
                  2
                )} bt</td
              >
            </tr>
          </table>

          <button class="btn btn-info" type="submit">Save</button>
        </form>
      {/if}
    {/await}
  </div>
</div>

<style>
  .table {
    font-size: 0.55em;
  }

  input {
    font-size: 0.7em;
  }
</style>
